<template>
  <div :class="['menu-header', {'menu-header--collapsed': collapsed}]">
    <v-row
      no-gutters
      align="center"
      :class="['menu-header-row', {'menu-header-row--collapsed': collapsed}]"
    >
      <v-col
        v-if="collapsed"
        cols="auto"
        sm="auto"
        md="auto"
        class="brand-col-collapsed"
      >
        <div class="collapsed-icon-wrapper">
          <v-btn
            ref="collapseButton"
            icon
            x-small
            class="collapse-button"
            aria-label="Expand sidebar"
            @mouseenter="onButtonHover"
            @mouseleave="onButtonLeave"
            @click="onButtonClick"
          >
            <v-icon :size="showDockIcon ? 19 : 22">
              {{ showDockIcon ? 'mdi-dock-left' : 'mdi-star-four-points' }}
            </v-icon>
          </v-btn>
        </div>
      </v-col>

      <v-col
        v-else
        cols="auto"
        sm="auto"
        md="auto"
        class="brand-col"
      >
        <div class="brand">
          <v-icon
            size="22"
            class="brand-icon"
          >
            mdi-star-four-points
          </v-icon>
          <span class="brand-name">Newton</span>
        </div>
      </v-col>

      <v-col
        v-if="!collapsed"
        class="spacer-col"
      />

      <v-col
        v-if="!collapsed"
        cols="auto"
        sm="auto"
        md="auto"
        class="collapse-col"
      >
        <v-btn
          icon
          x-small
          class="collapse-button"
          aria-label="Toggle sidebar"
          @click="$emit('toggle-collapse')"
        >
          <v-icon size="19">
            mdi-dock-right
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name : 'MenuHeader',
  props: {
    collapsed: {
      type   : Boolean,
      default: false
    }
  },
  data () {
    return {
      showDockIcon  : false,
      tooltipElement: null
    }
  },
  watch: {
    collapsed (newVal) {
      if (newVal) {
        this.showDockIcon = false
        this.removeTooltip()
      }
    }
  },
  beforeDestroy () {
    this.removeTooltip()
  },
  methods: {
    onButtonHover () {
      this.showDockIcon = true
      this.showTooltip()
    },

    onButtonLeave () {
      this.showDockIcon = false
      this.hideTooltip()
    },

    onButtonClick () {
      this.removeTooltip()
      this.$emit('toggle-collapse')
    },

    showTooltip () {
      if (!this.collapsed) {
        return
      }

      const button = this.$refs.collapseButton?.$el
      if (!button) return

      this.removeTooltip()

      const tooltip = document.createElement('div')
      tooltip.className = 'menu-header-tooltip'
      tooltip.textContent = 'Open slider'

      const rect = button.getBoundingClientRect()

      tooltip.style.cssText = `
        position: fixed;
        left: ${rect.left + rect.width / 2 + 20}px;
        top: ${rect.top + rect.height / 2}px;
        transform: translate(0, -50%);
        padding: 3px 8px;
        background: rgba(255, 255, 255, 0.95);
        color: #041f30;
        font-family: 'Inter';
        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        white-space: nowrap;
        z-index: 1000;
        pointer-events: none;
        opacity: 0;
        animation: tooltipFadeInRight 0.15s ease forwards;
      `

      document.body.appendChild(tooltip)
      this.tooltipElement = tooltip
    },

    hideTooltip () {
      this.removeTooltip()
    },

    removeTooltip () {
      if (this.tooltipElement) {
        this.tooltipElement.remove()
        this.tooltipElement = null
      }
    }
  }
}
</script>

<style scoped>
.menu-header {
  padding: 20px 16px 40px;
  flex: 0 0 auto;
  min-height: 70px;
}

.menu-header--collapsed {
  min-height: auto;
}

.menu-header-row {
  width: 100%;
  min-width: 0;
}

.menu-header-row--collapsed {
  justify-content: center;
}

.brand-col,
.spacer-col,
.collapse-col,
.brand-col-collapsed {
  min-width: 0;
}

.collapse-col {
  display: flex;
  justify-content: flex-end;
}

.menu-header-row--collapsed .collapse-col {
  justify-content: center;
}

.brand {
  display: flex;
  align-items: center;
  min-width: 0;
}

.brand-icon {
  color: #93de94 !important;
  margin-right: 8px;
}

.brand-name {
  color: #041f30;
  font-family: 'Aeonik';
  font-size: 17px;
  font-weight: 700;
  line-height: 21px;
}

.collapse-button {
  position: relative !important;
  isolation: isolate !important;
  color: #041f30 !important;
  opacity: 0.9 !important;
  flex-shrink: 0;
}

.collapse-button::before {
  content: '';
  position: absolute;
  inset: -4.5px;
  border-radius: 8px;
  background: #ffffff !important;
  opacity: 0;
  z-index: -1;
  transition: opacity 0.15s ease;
}

.collapse-button:hover::before {
  opacity: 1 !important;
}

.collapse-button:hover {
  background: transparent !important;
}

.brand-col-collapsed .collapse-button .v-icon {
  color: #93de94 !important;
}

.brand-col-collapsed .collapse-button:hover .v-icon {
  color: #0d2940 !important;
}

.collapsed-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
</style>

<style>
@keyframes tooltipFadeInRight {
  from {
    opacity: 0;
    transform: translate(0, -50%) translateX(-4px);
  }
  to {
    opacity: 1;
    transform: translate(0, -50%) translateX(0);
  }
}
</style>
